import script from "./PartnerInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerInfoModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=9c50f9c0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c50f9c0"]])

export default __exports__